import { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import Option from './Option';
import { classes } from '@/helpers/styling';
import useMounted from '@/hooks/utility/useMounted';

const SelectorListHidden = ({
  options,
  onOptionEnterView,
  onOptionLeaveView,
  onRenderOption,
  className,
  optionClassName,
  rootMarginAdjustment,
  OptionComponent
}) => {
  // This ensures that the updated intersectionRoot element is passed when the listRef is attached
  useMounted({ updateState: true });

  const listRef = useRef();

  return (
    <ul
      className={ classes('selector-h__list', className, { '--justify-content-start': false }) }
      ref={ listRef }
    >
      { options.map(({ id: optionId, value }) => {
        return (
          <li
            className={ classes('selector-h__option-wrapper', optionClassName) }
            key={ optionId }
          >
            <Option
              hidden
              id={ optionId }
              intersectionRoot={ listRef.current }
              onEnterView={ onOptionEnterView }
              onLeaveView={ onOptionLeaveView }
              onRenderOption={ onRenderOption }
              OptionComponent={ OptionComponent }
              rootMarginAdjustment={ rootMarginAdjustment }
              value={ value }
            />
          </li>
        );
      }) }
    </ul>
  );
};

SelectorListHidden.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  onOptionEnterView: PropTypes.func,
  onOptionLeaveView: PropTypes.func,
  onRenderOption: PropTypes.func,
  className: PropTypes.string,
  optionClassName: PropTypes.string,
  rootMarginAdjustment: PropTypes.number,
  OptionComponent: PropTypes.element
};

SelectorListHidden.defaultProps = {
  options: [],
  onOptionEnterView: undefined,
  onOptionLeaveView: undefined,
  onRenderOption: undefined,
  className: '',
  optionClassName: '',
  rootMarginAdjustment: 0,
  OptionComponent: undefined
};

export default memo(SelectorListHidden);